module.exports = __webpack_public_path__ + "img/calendar-and-clock-time.9b0c92b3.svg";